import React, { useState, useEffect } from "react";
import { useStripe, CardElement, useElements } from "@stripe/react-stripe-js";
import { Primary } from "../../stories/Button.stories";
import UserService from "../../services/user.service";
import { useHistory } from "react-router-dom";
import { Small } from "../../stories/Input.stories";
import Select from "react-select";
import { customStyles, customStylesError } from "../../common/CustomStyles";
import ToastBlockContainer from "../../common/ToastBlockContainer";

const CheckoutForm = (props) => {
  console.log(props);
  const cardStyle = {
    style: {
      base: {
        color: "#495057",
        fontSize: "16px",
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        "::placeholder": {
          color: "#6c757d",
          opacity: 1,
        },
        padding: "10px",
        backgroundColor: "#fff",
        border: "1px solid #ced4da",
        borderRadius: "4px",
        height: "41.6px",
      },
      invalid: {
        color: "#dc3545",
        iconColor: "#dc3545",
      },
    },
  };
  var splitUrl = window.location.href.split("/");
  let history = useHistory();
  var isCardComplete = false;
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  var uuidDetails = localStorage.getItem("uuid");
  const [showToast, setShowToast] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [totalLength, setTotalLength] = useState([]);
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [exist, setexist] = useState(false);
  const [DetailsSave, setDetailsSave] = useState({});
  const [err, seterr] = useState(false);
  const [trialCheck, settrialCheck] = useState([]);
  const [trialCheck1, settrialCheck1] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState({
    value: "",
    label: "Select a category",
  });
  const countries = [
    { value: "usd", label: "United States" },
    { value: "gbp", label: "United Kingdom" },
  ];

  useEffect(() => {
    if (splitUrl[3] !== "subscription") {
      // get family details
      UserService.getUserSingleFamilyDetails(uuidDetails, UserDetails.id).then(
        (response) => {
          if (response && response.FamilyData) {
            UserService.getSubsciptionStripe(
              response.FamilyData.Family.Family_Subscription
                .stripeSubscriptionId
            ).then((res) => {
              settrialCheck(res);
              settrialCheck1(res.items.data[0]);
            });
          }
        },
        () => {}
      );

      UserService.getUserAccountPlan(UserDetails.uuid).then(
        (response) => {
          console.log(response);
          var newData = [];
          for (var i = 0; i < response.usersFamilyData.length; i++) {
            if (response.usersFamilyData[i].isAo === true) {
              newData.push(response.usersFamilyData[i]);
            }
          }
          console.log(newData);
          setTotalLength(newData);
        },
        () => {}
      );
    }
  }, []);

  const initialValues = {
    name:
      UserDetails.firstname === "null"
        ? ""
        : UserDetails.firstname + " " + UserDetails.lastname,
    postcode: "",
    country: "GB",
    isCardValid: false,
    last4digit: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const handleCardChange = (e) => {
    if (e.complete) {
      isCardComplete = true;
      setFormValues({ ...formValues, isCardValid: isCardComplete });
    } else {
      setLoading(false);
      setFormValues({ ...formValues, isCardValid: false });
    }
  };

  const handleChange = (e, action) => {
    if (action?.name === "postcode") {
      setSelectedCountry(e);
      setFormValues({ ...formValues, postcode: e.value });
    }

    if (e?.target?.name === "name") {
      const { name, value } = e.target;
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
    setLoading(true);
  };

  const validate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.msg = "Please enter card details";
      errors.name = "Yes";
    }
    if (!values.postcode) {
      errors.msg = "Please enter valid postcode";
      errors.postcode = "Yes";
    }
    if (!values.isCardValid) {
      errors.msg = "Please enter card information";
      errors.isCardValid = "Yes";
    }
    setLoading(false);
    return errors;
  };

  // 30 days from today
  const today = new Date();
  today.setDate(today.getDate() + 30);
  const unixTimestamp = Math.floor(today.getTime() / 1000);

  //15 minutes from today
  // var date = new Date();
  // date.setDate(date.getDate());
  // const unixTimeVal = Math.floor(date.getTime() / 1000);
  // const unixTimestamp = unixTimeVal + 900;

  useEffect(() => {
    // handle confirm submit
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      if (!stripe || !elements) {
        console.error(
          "Stripe.js has not loaded yet. Make sure it is initialized properly."
        );
        setLoading(false);
        return;
      }

      const cardElement = elements.getElement(CardElement);

      if (!cardElement) {
        console.error("CardElement is not mounted or could not be retrieved.");
        setLoading(false);
        return;
      }
      stripe
        .createPaymentMethod({
          type: "card",
          card: elements.getElement(CardElement),
          billing_details: {
            name: formValues.name,
            address: {
              country: formValues.country,
              postal_code: formValues.postcode,
            },
          },
        })
        .then(function (result) {
          UserService.userCheckAPI({
            email: UserDetails.email,
          }).then((valRes) => {
            console.log(valRes);
            let attachData = {
              customer:
                valRes.TotalCount === 1
                  ? valRes.data.rows[0].stripeCustomerId
                  : props.customerId,
            };
            if (result.paymentMethod === undefined) {
              seterr(true);
              setLoading(false);
            } else {
              seterr(false);
              setexist(false);
              UserService.attachPaymentMethod(
                attachData,
                result.paymentMethod.id
              ).then(
                (resp) => {
                  console.log(resp);
                  debugger;
                  if (splitUrl[3] !== "manageSubscription") {
                    debugger;
                    let updateData = {
                      "invoice_settings[default_payment_method]":
                        result.paymentMethod.id,
                    };
                    UserService.updateCustomerStripe(
                      updateData,
                      resp.customer
                    ).then(
                      () => {
                        if (splitUrl[3] === "downgradeSubscription") {
                          debugger;
                          if (
                            props.planDetails.uniqueIdentifier ===
                              "couple-monthly" ||
                            props.planDetails.uniqueIden === "couple-monthly"
                          ) {
                            debugger;
                            if (
                              props.planDa.uniqueIdentifier ===
                                "single-yearly" ||
                              props.planDa.uniqueIden === "single-yearly"
                            ) {
                              history.push({
                                pathname: `/downgrade_Subscription/${splitUrl[4]}`,
                                state: {
                                  previous: props.planDetails,
                                  current: props.planDa,
                                  stripeCusID: props,
                                },
                              });
                            } else {
                              debugger;
                              UserService.upgradeSubscription(
                                splitUrl[4],
                                props.planDa.id,
                                props.SubscriptionId
                              ).then(() => {
                                let subsciptionData = {
                                  trial_end: "now",
                                  proration_behavior: "always_invoice",
                                  billing_cycle_anchor: "now",
                                  "items[0][plan]": props.planDa.stripePriceId,
                                  "items[0][id]": trialCheck1.id,
                                };
                                UserService.updateSubsciptionStripe(
                                  subsciptionData,
                                  trialCheck.id
                                ).then((response) => {
                                  if (
                                    response.status !== 400 &&
                                    response.status !== 404
                                  ) {
                                    history.push({
                                      pathname: `/dashboard/${splitUrl[4]}`,
                                    });
                                  }
                                });
                              });
                            }
                          } else if (
                            props.planDetails.uniqueIdentifier ===
                              "family-monthly" ||
                            props.planDetails.uniqueIden === "family-monthly"
                          ) {
                            debugger;
                            if (
                              props.planDa.uniqueIdentifier ===
                                "single-yearly" ||
                              props.planDa.uniqueIden === "single-yearly" ||
                              props.planDa.uniqueIdentifier ===
                                "couple-yearly" ||
                              props.planDa.uniqueIden === "couple-yearly"
                            ) {
                              history.push({
                                pathname: `/downgrade_Subscription/${splitUrl[4]}`,
                                state: {
                                  previous: props.planDetails,
                                  current: props.planDa,
                                  stripeCusID: props,
                                },
                              });
                            } else {
                              debugger;
                              UserService.upgradeSubscription(
                                splitUrl[4],
                                props.planDa.id,
                                props.SubscriptionId
                              ).then(() => {
                                let subsciptionData = {
                                  trial_end: "now",
                                  proration_behavior: "always_invoice",
                                  billing_cycle_anchor: "now",
                                  "items[0][plan]": props.planDa.stripePriceId,
                                  "items[0][id]": trialCheck1.id,
                                };
                                UserService.updateSubsciptionStripe(
                                  subsciptionData,
                                  trialCheck.id
                                ).then((response) => {
                                  if (
                                    response.status !== 400 &&
                                    response.status !== 404
                                  ) {
                                    history.push({
                                      pathname: `/dashboard/${splitUrl[4]}`,
                                    });
                                  }
                                });
                              });
                            }
                          } else {
                            debugger;
                            UserService.upgradeSubscription(
                              splitUrl[4],
                              props.planDa.id,
                              props.SubscriptionId
                            ).then(() => {
                              let subsciptionData = {
                                trial_end: "now",
                                proration_behavior: "always_invoice",
                                billing_cycle_anchor: "now",
                                "items[0][plan]": props.planDa.stripePriceId,
                                "items[0][id]": trialCheck1.id,
                              };
                              UserService.updateSubsciptionStripe(
                                subsciptionData,
                                trialCheck.id
                              ).then((response) => {
                                if (
                                  response.status !== 400 &&
                                  response.status !== 404
                                ) {
                                  history.push({
                                    pathname: `/dashboard/${splitUrl[4]}`,
                                  });
                                }
                              });
                            });
                          }
                        } else {
                          // create subscription
                          let subsciptionData = {
                            customer: resp.customer,
                            "items[0][price]": props.planDetails.stripePriceId
                              ? props.planDetails.stripePriceId
                              : props.planDetails.stripePric,
                          };

                          if (totalLength.length === 0) {
                            subsciptionData.trial_end = unixTimestamp;
                          }
                          UserService.createSubsciptionStripe(
                            subsciptionData
                          ).then(
                            (response) => {
                              if (response) {
                                let createFamilyData = {
                                  stripePaymentId: response.latest_invoice,
                                  stripeSubscriptionId: response.id,
                                  stripeCustomerId: response.customer,
                                  familyName: props.familyName, //UserDetails.lastname,
                                  planId: props.planDetails.id, // response.plan.product,
                                  aoUser: UserDetails.uuid,
                                  subscriptionObject: response,
                                  freeTrialStatus:
                                    response.status === "trialing"
                                      ? true
                                      : false,
                                };

                                localStorage.setItem(
                                  "UserA",
                                  JSON.stringify(
                                    props.planDetails.uniqueIdentifier
                                      ? props.planDetails.uniqueIdentifier
                                      : props.planDetails.uniqueIden
                                  )
                                );
                                UserService.createFamily(createFamilyData).then(
                                  (res) => {
                                    setDetailsSave(res);
                                    localStorage.setItem(
                                      "UserDA",
                                      res.FamilyData.id
                                    );
                                    window.history.pushState(
                                      null,
                                      "",
                                      history.push({
                                        pathname: "/confirmation",
                                        familyUUID: res.FamilyData.uuid,
                                        fromPaymentSuccsess: true,
                                      })
                                    );
                                    window.onpopstate = function () {
                                      window.history.pushState(
                                        null,
                                        "",
                                        history.push({
                                          pathname: "/confirmation",
                                          familyUUID: res.FamilyData.uuid,
                                          fromPaymentSuccsess: true,
                                        })
                                      );
                                    };

                                    localStorage.setItem(
                                      "UserB",
                                      res.FamilyData.uuid
                                    );
                                  }
                                );
                              }
                            },
                            () => {
                              setLoading(false);
                            }
                          );
                        }
                      },
                      () => {
                        setLoading(false);
                      }
                    );
                  } else {
                    debugger;
                    setLoading(false);
                    // setShowToast(true);
                    // setSuccessToast(true);
                    // setToastMessage("Your card successfully added");
                    console.log(resp);
                    let updateData = {
                      "invoice_settings[default_payment_method]": resp.id,
                    };
                    UserService.updateCustomerStripe(
                      updateData,
                      resp.customer
                    ).then(
                      (respo) => {
                        console.log(respo);
                        setShowToast(true);
                        setSuccessToast(true);
                        setToastMessage(
                          "Card has been updated as your default payment card"
                        );
                        setTimeout(() => {
                          window.location.reload();
                        }, 2500);
                      },
                      (error) => {}
                    );
                    // props.setNewCard(resp);
                    // props.cardsaved.push(result.paymentMethod.card.last4);
                  }
                },
                () => {
                  setLoading(false);
                }
              );
            }
          });
        })
        .catch((error) => {
          console.error("Stripe error:", error);
          setLoading(false);
          // Handle the error
        });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [formErrors]);

  return (
    <>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      <form
        className={`payment-form text-start w-100 ${
          splitUrl[3] !== "manageSubscription" &&
          splitUrl[3] !== "downgradeSubscription" &&
          "mb-6rem"
        }`}
        onSubmit={handleSubmit}
      >
        <label
          className={
            formErrors.name ? "invalid-text form-label mb-1" : "form-label mb-1"
          }
        >
          Name on the card
        </label>
        <Small
          type="test"
          errorClass={formErrors.name ? "invalid-input" : ""}
          placeholder="John Mike"
          size="small"
          name="name"
          value={formValues.name}
          onChange={handleChange}
          className={`form-control ${
            formErrors.name ? `invalid-border` : "mb-3"
          }`}
        />
        {formErrors.name && (
          <p className="invalid-text fs-12 mt-1">
            Please enter valid card details
          </p>
        )}

        <label
          className={
            exist || formErrors.isCardValid
              ? "invalid-text form-label mb-1"
              : "form-label mb-1"
          }
        >
          Card Number
        </label>
        <CardElement
          options={cardStyle}
          onChange={handleCardChange}
          className={`form-control card-element ${
            exist || formErrors.isCardValid ? `invalid-border` : `mb-3`
          }`}
        />
        {exist && (
          <p className="invalid-text fs-12 mt-2">
            Card already exist. Please use different card
          </p>
        )}
        {formErrors.isCardValid && (
          <p className="invalid-text fs-12 mt-1">
            Please enter valid card information
          </p>
        )}
        <label
          className={
            formErrors.postcode
              ? "invalid-text form-label mb-1"
              : "form-label mb-1"
          }
        >
          Country
        </label>
        <Select
          styles={formErrors.postcode ? customStylesError : customStyles}
          options={countries}
          defaultValue={{
            value: "",
            label: "Select a category",
          }}
          value={selectedCountry}
          onChange={handleChange}
          name="postcode"
        />
        {formErrors.postcode && (
          <p className="invalid-text fs-12 mt-1 mb-3">
            Please select country from the dropdown
          </p>
        )}
        <div className="bold-colour mb-3 fs-12">
          By providing your card information, you allow Elderlylife to charge
          your card for future payments in accordance with their terms
        </div>
        <div className="text-center">
          <Primary
            children={props.card ? "Update" : "pay"}
            variant="primary"
            size="mediumbtn"
            type="submit"
            className="btn btn-primary w-100"
            isLoading={loading ? "true" : "false"}
          />
        </div>
        <div className="my-2 fs-12 d-flex align-items-center justify-content-center gap-1">
          <span style={{ color: "rgb(60, 66, 87)" }}>Powered by</span>{" "}
          <a
            href="https://stripe.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "rgb(84, 105, 212)" }}
          >
            Stripe
          </a>
        </div>
      </form>
    </>
  );
};

export default CheckoutForm;
